module.exports = __webpack_public_path__ + "img/companion-poster.420a753d.jpg";